import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import BackButton from "../../assets/logo/BackButton.svg";

const ReviewApplication = ({ handleClickSetFive, handlePrevious }) => {
  const [selectedOption, setSelectedOption] = useState("");

  const handleOptionChange = (newSelection) => {
    if (newSelection !== null) {
      setSelectedOption(newSelection);
      handleClickSetFive(newSelection);
    }
  };

  const handleContinue = () => {
    // Logic to handle the next step (e.g., navigate to next page)
    // if (onNext) onNext();
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        textAlign: "left",
        alignItems: "center",
        padding: { xs: "0", md: "5rem" },
        paddingTop: { xs: "1rem" },
        maxWidth: { xs: "450px", md: "900px" },
      }}
    >
      {/* <Box
            sx={{
              display: "flex",
              width: "100%",
              maxWidth: "70vw",
              mb: 4,
            }}
          >
            <img
              src="https://path-to-your-logo.com/logo.png"
              alt="Rise Formations Logo"
              style={{ width: "150px", marginRight: "1rem" }}
            />
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", color: "#3D3D3D" }}
            >
              RiseFormations
            </Typography>
          </Box> */}
      {/* Main Heading */}
      {/* <Box> */}{" "}
      <Box>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2 }}>
          Would you like us to review your application before submission? ​
        </Typography>

        {/* Subtitle */}

        <Typography
          variant="body1"
          sx={{
            fontSize: "1.2rem",
            color: "#5A5A5A",
            mb: 4,
          }}
        >
          Companies House may reject the application should any information not
          meet their compliance requirements.
          <br />
          <br />
          Our team are on hand to support with a professional review of your
          application to ensure it complies with Companies House standards.
        </Typography>

        {/* Options (ToggleButtonGroup) */}
        <Button
          variant="outlined"
          onClick={() => handleOptionChange("yes")}
          sx={{
            border: "2px solid",
            borderColor:
              selectedOption === "yes" ? "#10182C" : "#D1D1D1",
            borderRadius: "8px",
            fontSize: "1rem",
            padding: "0.9rem",
            // fontWeight: "bold",
            color:
              selectedOption === "yes" ? "#10182C" : "#5A5A5A",
            marginBottom: "1rem",
            textTransform: "none",
            width: { xs: "19rem", md: "42rem" },
            "&:hover": {
              backgroundColor: "#181e54",
              color: "white",
            },
          }}
        >
          Yes, please review my application (+£20 + VAT)
        </Button>
        <br />
        {/* Option 2: No, proceed without checking my answers */}
        <Button
          variant="outlined"
          onClick={() => handleOptionChange("no")}
          sx={{
            border: "2px solid",
            borderColor:
              selectedOption === "no" ? "#10182C" : "#D1D1D1",
            borderRadius: "8px",
            fontSize: "1rem",
            // fontWeight: "bold",
            width: { xs: "19rem", md: "42rem" },
            padding: "0.9rem",
            color: selectedOption === "no" ? "#10182C" : "#5A5A5A",
            textTransform: "none",
            marginBottom: "2rem",
            "&:hover": {
              backgroundColor: "#181e54",
              color: "white",
            },
          }}
        >
          No, proceed without checking my answers
        </Button>

        {/* Previous Button */}
        <Box display="flex">
          <Button
            // variant="contained"
            onClick={handlePrevious}
            sx={{
              color: "#000",
              fontSize: "1rem",
              textTransform: "none",
              marginBottom: "0.75rem",
              marginRight: "0.75rem",
            }}
          >
            <img width={"70px"} src={BackButton} />
          </Button>

          {/* Continue Button */}
          {/* <Button
            variant="contained"
            sx={{
              backgroundColor: "#10182C",
              color: "#fff",
              borderRadius: "20px",
              // padding: "0.75rem 2rem",
              fontSize: "1.25rem",
              fontWeight: "bold",
              textTransform: "none",
              ":hover": {
                backgroundColor: "#5900CC",
              },
            }}
            onClick={() => handleClickSetFive(selectedOption)}
          >
            Continue
          </Button> */}
        </Box>
      </Box>
    </Box>
  );
};

export default ReviewApplication;
